import { TFunction } from 'i18next'

import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

import { TrackingContext } from '../../../../enums/trackingContext'
import { getTrackingContextToModalContentVariant } from '../constants/getTrackingContextToModalContentVariant'
import { ResolvedModalContent } from '../types/modalContent'

interface GetModalContentParams {
  effectivePlan?: SubscriptionPlan
  isSourceBilly?: boolean
  planName?: string
  t: TFunction
  trackingContext: TrackingContext
}

export const getModalContent = (params: GetModalContentParams): ResolvedModalContent | undefined => {
  const { effectivePlan, isSourceBilly = false, planName = '', t, trackingContext } = params

  let contextualModalContent
  const trackingContextToModalContentVariant = getTrackingContextToModalContentVariant(t, planName)

  for (const [contexts, variant] of trackingContextToModalContentVariant) {
    if (contexts.includes(trackingContext)) {
      contextualModalContent = variant
      break
    }
  }

  if (!contextualModalContent) {
    return undefined
  }

  const billyOverride = isSourceBilly ? contextualModalContent.billyOverrides : undefined
  const planOverride = effectivePlan ? contextualModalContent.planOverrides?.[effectivePlan] : undefined

  return {
    body: billyOverride?.body ?? planOverride?.body ?? contextualModalContent.body,
    bullets: billyOverride?.bullets ?? planOverride?.bullets ?? contextualModalContent.bullets,
    cta: billyOverride?.cta ?? planOverride?.cta ?? contextualModalContent.cta,
    heading: billyOverride?.heading ?? planOverride?.heading ?? contextualModalContent.heading,
  }
}
